module.exports = __webpack_public_path__ + "static/media/temp_6.c5144e3c.jpg";